import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '报表样式',
    type: 'AMAR_RS',
    mapProp: 'map',
}